module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/user3-a080ab5581bfca021e9bcef2aec500d3.jpg";